
export default class {
  addExhibitTitle (spotName, winnerName) {
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.width = 6024
    canvas.height = 256
    canvas.style.backgroundColor = 'transparent !important'
    //  Spot name
    canvas.style.letterSpacing = '1px'
    context.textAlign = 'center'
    context.font = '140px jaf-domus'
    context.fillStyle = 'rgba(0,0,0,1)'
    context.fillText(spotName, canvas.width / 2, 120)

    //  Gallery title
    canvas.style.letterSpacing = '3px'
    context.textAlign = 'center'
    context.font = '52px jaf-domus'
    context.fillStyle = 'rgba(0,0,0,1)'
    context.fillText('T I T T A  M O T  H I M M E L E N !', canvas.width / 2, 135)
    //  Borders
    /*
    context.lineWidth = 4
    context.rect(0, 0, 512, 256)
    context.stroke()
    */
    //  three js texture
    let texture = new window.THREE.Texture(canvas)
    texture.needsUpdate = true
    let material = new window.THREE.MeshBasicMaterial({map: texture, transparent: true, alphaTest: 0.1})
    //  texture.repeat.set(1, 1)
    let mesh = new window.THREE.Mesh(
        new window.THREE.PlaneGeometry(40, 4, 1),
        material
      )
    mesh.dynamic = true
    return mesh
  }
  addSoloTitle (spotName) {
    //  console.log('adding solo title')
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.width = 1024
    canvas.height = 256
    canvas.style.backgroundColor = 'transparent !important'
    canvas.style.backgroundColor = 'rgba(255,255,255,1)'
    context.textAlign = 'center'
    context.font = '120px jaf-domus'
    context.fillStyle = 'rgba(255,255,255,1)'
    context.fillText(spotName, canvas.width / 2, canvas.height / 2)
    let texture = new window.THREE.Texture(canvas)
    texture.needsUpdate = true
    let material = new window.THREE.MeshBasicMaterial({map: texture, transparent: true, alphaTest: 0.1})
    let mesh = new window.THREE.Mesh(
        new window.THREE.PlaneGeometry(60.2, 15.64, 1),
        material
      )
    mesh.position.y = 10
    mesh.position.z = 0
    mesh.dynamic = true
    return mesh
  }
  addChallengeButton (name) {
    //  To challange
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.width = 1024
    canvas.height = 128
    context.fillStyle = '#2f4efd'
    context.fillRect(0, 0, canvas.width, canvas.height)
    canvas.style.letterSpacing = '1px'
    context.textAlign = 'center'
    context.font = '56px jaf-domus'
    context.fillStyle = 'rgba(255,255,255,1)'
    context.fillText('Challenge photo', canvas.width / 2, 86)
    //  three js texture
    let texture = new window.THREE.Texture(canvas)
    texture.needsUpdate = true
    let material = new window.THREE.MeshBasicMaterial({map: texture})
    material.transparent = true
    texture.repeat.set(1, 1)
    let mesh = new window.THREE.Mesh(
        new window.THREE.PlaneGeometry(8.5, 1.1, 1),
        material
      )
    mesh.position.y = -8.1
    mesh.name = name + '_challenge'
    return mesh
  }
  addViewButton (name) {
    //  To challange
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.width = 1024
    canvas.height = 128
    context.fillStyle = '#fff'
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.fillStyle = '#fff'
    context.fillRect(4, 4, canvas.width - 8, canvas.height - 8)
    canvas.style.letterSpacing = '1px'
    context.textAlign = 'center'
    context.font = '56px jaf-domus'
    context.fillStyle = 'rgba(0,0,0,1)'
    context.fillText('KLICKA  PÅ FOTO', canvas.width / 2, 86)
    //  three js texture
    let texture = new window.THREE.Texture(canvas)
    texture.needsUpdate = true
    let material = new window.THREE.MeshBasicMaterial({map: texture})
    material.transparent = true
    texture.repeat.set(1, 1)
    let mesh = new window.THREE.Mesh(
        new window.THREE.PlaneGeometry(8.3, 1.1, 1),
        material
      )
    mesh.position.y = -9.4
    mesh.name = name + '_view'
    return mesh
  }
  addWhiteBack () {
    let groundGeo = new window.THREE.PlaneBufferGeometry(10, 14)
    let groundMat = new window.THREE.MeshBasicMaterial({color: 0xFFFFFF})
    //  groundMat.color.setHex( 0x2962FF  );
    let ground = new window.THREE.Mesh(groundGeo, groundMat)
    ground.position.y = -4.3
    ground.position.z = -0.1
    ground.castShadow = false
    return ground
  }
  addSpotSpotLight () {
    var spotlight = new window.THREE.SpotLight(0xffffff, 1.5, 60, 1.05, 1.05, 2)
    spotlight.castShadow = true
    spotlight.position.set(0, 10, 0)
    spotlight.target.position.set(0, 0, 0)
    spotlight.castShadow = true
    return spotlight
  }
  addConeArrow () {
    var arrow = new window.THREE.CylinderGeometry(25, 0, 90, 16)
    var mat = new window.THREE.MeshPhongMaterial({
      color: 0xD1AD68,
      emissive: 0xD1AD68,
      emissiveIntensity: 0
    })
    var m = new window.THREE.Mesh(arrow, mat)
    m.position.y = 65
    return m
  }
}



// WEBPACK FOOTER //
// ./src/classes/spot3d.js